export default {"src":"/_next/static/media/hand-shake.f3bb374d.svg","height":36,"width":50,"blurWidth":0,"blurHeight":0};